import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { ExplorableItemDefinition, SpaceDefinition, ContentTypeFilterClause } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { GroupContentType } from '~src/ts/models/ContentTypes';
import { Groups } from '~src/userManagement/groups/Groups';

import { getNoDefaultFilters } from './getDefaultFilters';

export const GroupDefinition: ExplorableItemDefinition & SpaceDefinition<'group'> = {
  itemType: 'siteuser',
  contentType: 'group',
  singularName: Messages.group,
  pluralName: Messages.groups,
  emptyStateMessage: Messages.groupsEmptyMessage,
  contentFilterKeys: GroupContentType.filterKeys,
  defaultFilters: getNoDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  headerIconPath: () => imgPath('spaces_masthead_groups.svg'),
  filterClause: ServerFilterClauses.ContentType(['siteuser']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return Groups.all();
  },
  getContentInfo: () => {
  },
  contentSpaceUrl: () => '',
  supportedDisplayModes: ['list'],
};
